import React, { Component } from "react";
import { Row, Col, Card, Button, CardHeader, UncontrolledAlert, CardBody } from "reactstrap";
import Formsy from "formsy-react";
import { Spinner } from "../../../Shared";

import { TextInput } from "../../../Shared/Forms";
import TextEditor from "../../../Shared/Forms/TextEditor";
import { MySelect } from "../../../Shared/Forms/Select";

import { UploadFile } from "../../../Shared/FileUpLoad";

import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../../_constants/tutorialmessages/ManualMessages";

class UpLoadContentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canSubmit: false,
            isReset: false,
            typeOfSubmit: null,
            titleJoyRide: false,
            mainJoyRide: false,
            run: false,
            stepIndex: 0,

            steps: [
                {
                    target: tourMessages.instructorImage.target,
                    content: (
                        <div>
                            <p>{tourMessages.instructorImage.title}</p>
                            <p style={{ color: "blue", fontStyle: "italic", fontSize: "15px" }}>{tourMessages.instructorImage.content}</p>
                        </div>
                    ),
                    placement: "left",
                    locale: { skip: "SKIP", close: "Next" }
                },
                {
                    target: tourMessages.instructorPost.target,
                    content: (
                        <div>
                            <p>{tourMessages.instructorPost.title}</p>
                        </div>
                    ),
                    placement: "left",
                    locale: { skip: "SKIP", close: "Next" }
                },
                {
                    target: tourMessages.instructorDraft.target,
                    content: (
                        <div>
                            <p>{tourMessages.instructorDraft.title}</p>
                        </div>
                    ),
                    placement: "left",
                    locale: { skip: "SKIP", close: "Next" }
                },
                {
                    target: tourMessages.instructorPublish.target,
                    content: (
                        <div>
                            <p>{tourMessages.instructorPublish.title}</p>
                            <p style={{ color: "blue", fontStyle: "italic", fontSize: "15px" }}>{tourMessages.instructorPublish.content}</p>
                        </div>
                    ),
                    placement: "left",
                    locale: { skip: "SKIP" }
                },
                tourMessages.default
            ]
        };

        this.defaultInput = React.createRef();
        this.focusTextInput = this.focusTextInput.bind(this);
    }
    focusTextInput() {
        this.defaultInput.current.reset();
    }

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    createRequest = data => {
        let request = { ...data };

        if (request.interestsIds && request.interestsIds.length) {
            const arrayOfIds = request.interestsIds.map(interest => interest.id);

            request = {
                interests: arrayOfIds,
                ...request
            };
            delete request.interestsIds;
        }
        return request;
    };

    draftPost = () => {
        this.setState(
            {
                typeOfSubmit: "draftButton"
            },
            this.refs.instructorPostEditor.submit
        );
    };

    publishPost = () => {
        this.setState(
            {
                typeOfSubmit: "publishButton"
            },
            this.refs.instructorPostEditor.submit
        );
    };

    handleSubmit = data => {
        let imageData = data && data.image && data.image.substr(22);

        if (this.state.typeOfSubmit === "draftButton") {
            let newRefineData = {
                title: data.title,
                body: data.body,
                interestId: data.interestId.id,
                base64Image: imageData || null
            };

            this.props.submitDraftPost(newRefineData);
        }
        if (this.state.typeOfSubmit === "publishButton") {
            //check if it an existing post
            if (this.props.editedPostId) {
               
                //if yes check if image is change
                if (this.imageId.checkEditedImageChange()) {
                  
                    //if image is change take the new image
                    let editedRefinedData = {
                        title: data.title,
                        body: data.body,
                        interestId: data.interestId.id,
                        base64Image: imageData
                    };
                   
                    this.props.submitPublishPost(editedRefinedData);
                } else {
                    //else send it null with the update post
                    let editedNoImageRefinedData = {
                        title: data.title,
                        body: data.body,
                        interestId: data.interestId.id,
                        base64Image: null
                    };
                   
                    this.props.submitPublishPost(editedNoImageRefinedData);
                }
            } else {
                let newRefineData = {
                    title: data.title,
                    body: data.body,
                    interestId: data.interestId.id,
                    base64Image: imageData || null
                };

                this.props.submitPublishPost(newRefineData);
            }
        }
    };

    resetForm = () => {
        this.refs.instructorPostEditor.reset();
        this.setState({ isReset: true });
        if (this.instructorInterestsRef) {
            this.instructorInterestsRef.interests.changeValue(null);
        }
        if (this.imageId) {
            this.imageId.cancelImage();
        }
    };

    ClearAll = () => {
        this.resetForm();
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.resetFormAfterPub) {
            this.ClearAll();
        }
        if (nextProps.imageUrl && this.imageId) {
            this.imageId.toDataURL(this.props.imageUrl, result => this.imageId.props.setValue(result));
        }
        if (nextProps.showNextJoyRide) {
            this.setState({ run: true });
            this.props.setNextJoyRide();
        }
    }
    //================TOUR GUIDE SECTION========================//
    handleJoyrideCallback = data => {
        const { action, index, status, type } = data;

        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
        } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
        } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            if ([STATUS.SKIPPED].includes(status)) {
                this.setState({ run: false });
            } else {
                this.setState({
                    run: false,
                    titleJoyRide: false,
                    mainJoyRide: false
                });
                this.props.routeChange();
            }
        }
    };
    setTitleJoyRide = () => {
        this.setState({
            run: false,
            titleJoyRide: true,
            mainJoyRide: false
        });
    };
    setMainJoyRide = () => {
        this.setState({
            run: false,
            titleJoyRide: false,
            mainJoyRide: true
        });
    };
    render() {
        const { canSubmit, isReset, run, steps, stepIndex, titleJoyRide, mainJoyRide } = this.state;
        const { submitting, error, submitSucessful, isEdit, postTitle, postBody, stopEdit, interestId, instructorInterests, stripPastedStyles, declineComment, imageUrl, setImageNull, editedPostId } = this.props;

        const selectInterestObject = instructorInterests && instructorInterests.filter(interest => interest.id === interestId);
        
        return (
            <div>
                <Joyride
                    steps={steps}
                    scrollToFirstStep
                    showProgress
                    showSkipButton
                    hideBackButton
                    styles={{
                        options: {
                            width: 300,
                            height: 60,
                            zIndex: 1000
                        }
                    }}
                    callback={this.handleJoyrideCallback}
                    run={mainJoyRide}
                    stepIndex={stepIndex}
                />
                {error ? <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert> : null}
                <Formsy ref="instructorPostEditor" onValidSubmit={this.handleSubmit} onValid={this.enableButton} onInvalid={this.disableButton} noValidate>
                    <Row>
                        <Col sm="7">
                            <MySelect
                                name="interestId"
                                value={selectInterestObject && selectInterestObject[0]}
                                title="Interest"
                                options={instructorInterests ? instructorInterests : []}
                                valueKey="id"
                                disabled={submitting}
                                labelKey="name"
                                innerRef={c => {
                                    this.interestId = c;
                                }}
                                isClearable={true}
                                required
                                joyRideRun={run}
                                setTitleJoyRide={this.setTitleJoyRide}
                            />
                            <TextInput
                                name="title"
                                value={postTitle}
                                required
                                disabled={submitting}
                                title="Title"
                                validations={{
                                    minLength: 3,
                                    maxLength: 100
                                }}
                                validationErrors={{
                                    minLength: "Minimum of 3 characters allowed",
                                    maxLength: "Maximum of 100 characters allowed"
                                }}
                                joyRideRun={titleJoyRide}
                                setMainJoyRide={this.setMainJoyRide}
                            />

                            <UploadFile
                                name="image"
                                type="file"
                                acceptedFormats={"jpg|jpeg|png|gif"}
                                disabled={submitting}
                                value={imageUrl || null}
                                innerRef={c => {
                                    this.imageId = c;
                                }}
                                maxSize={1048576}
                                imageUrl={imageUrl}
                                setImageNull={setImageNull}
                                className="joyride14"
                                editedPostId={editedPostId}
                                isUpLoading={false}
                            />
                            <Card>
                                <TextEditor
                                    name="body"
                                    value={postBody || null}
                                    required
                                    disabled={submitting}
                                    validations={{
                                        minLength: 13
                                    }}
                                    validationErrors={{
                                        minLength: "Minimum of 3 characters allowed"
                                    }}
                                    isReset={isReset}
                                    isEdit={isEdit}
                                    stopEdit={stopEdit}
                                    postBody={postBody}
                                    toolbarHidden={false}
                                    submitSucessful={submitSucessful}
                                    submitting={submitting}
                                    title="Text Edit"
                                    stripPastedStyles={stripPastedStyles}
                                    className="joyride15"
                                    //isViewOnly={false}
                                />
                            </Card>
                        </Col>

                        <Col>
                            <div className="mb-2">
                                <Card style={{ marginTop: "1rem" }}>
                                    <CardHeader>Publish</CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col sm="6">
                                                <Button size="lg" className="mb-2 joyride16" outline color="secondary" disabled={!canSubmit || submitting} onClick={this.draftPost} block>
                                                    {submitting ? <Spinner size="sm" /> : <span>Save Draft</span>}
                                                </Button>
                                            </Col>
                                            <Col sm="6">
                                                <Button size="lg" color="primary" id="2" block disabled={!canSubmit || submitting} onClick={this.publishPost} className="mb-2 joyride17">
                                                    Publish
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </div>
                            {declineComment ? (
                                <div>
                                    <Card>
                                        <CardHeader>Decline Comment</CardHeader>
                                        <CardBody>
                                            <p>{declineComment}</p>
                                            <br />
                                        </CardBody>
                                    </Card>
                                </div>
                            ) : null}
                        </Col>
                    </Row>
                </Formsy>
            </div>
        );
    }
}

export default UpLoadContentForm;
